import { categoryLinks } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            Browse by Category
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Explore all product categories available through BaseTao Spreadsheet.
            Click any category to start shopping on our main website.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categoryLinks.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3 text-center">
                <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-700 transition-colors duration-200 leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-xl text-sm font-semibold hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            View All Products on BaseTao Spreadsheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}